<em-main>
  <h3 class="layout--third-width" i18n>Soumission rapide</h3>

  <div class="w-full layout--column layout--gap-larger">
    <p-card class="p-card container">
      <h3 i18n>Informations du client</h3>
      <form [formGroup]="form">
        @if (dev) {
          <p-button label="Simulate" class="btn--simulate" (onClick)="simulateForm()"></p-button>
        }

        <div class="layout__inner-card margin--bottom-medium">
          <div class="layout--gap margin--bottom-medium">
            <div class="w-full">
              <label class="label-top" for="birthday" i18n>Date de naissance</label>
              <div class="layout--row layout--gap">
                <input
                  [formControl]="form.controls.birthday"
                  [dropSpecialCharacters]="false"
                  i18n-placeholder
                  placeholder="JJ/MM/AAAA"
                  id="birthday"
                  mask="d0/M0/0000"
                  pInputText />
                <em-text-indicator [text]="age?.toString()"></em-text-indicator>
              </div>
              @if (form.controls.birthday.hasError('atLeast18YearsOldInvalid')) {
                <p class="error margin--top-smaller" i18n> Doit être âgé de 18 ans et plus</p>
              }
            </div>

            <div class="w-full">
              <label class="label-top" for="sex" i18n>Sexe</label>
              <p-dropdown
                [options]="sexOptions | emTranslate"
                [formControl]="form.controls.sex"
                i18n-placeholder
                placeholder="Choisir"
                id="sex"
                optionLabel="name"
                optionValue="value"></p-dropdown>
            </div>

            <div class="w-full">
              <label class="label-top" for="smoker" i18n>Statut de fumeur</label>
              <p-dropdown
                [options]="smokerOptions | emTranslate"
                [formControl]="form.controls.smoker"
                i18n-placeholder
                placeholder="Choisir"
                id="smoker"
                optionLabel="label"
                optionValue="value"></p-dropdown>
            </div>

            <div class="w-full">
              <label class="label-top" for="surchargeRate" i18n
                >Taux de surprime
                <span
                  pTooltip="Les avenants invalidité et cancer ne peuvent pas être sélectionnées lorsqu'une surcharge est appliquée."
                  i18n-pTooltip
                  tooltipPosition="top"
                  tooltipStyleClass="surcharge-tooltip"
                  hideDelay="500"
                  class="pi pi-info-circle pb-1"></span
              ></label>
              <p-dropdown
                [options]="surchargeOptions | emTranslate"
                [formControl]="form.controls.surchargeRate"
                optionLabel="name"
                optionValue="value"
                id="surchargeRate"
                i18n-placeholder
                placeholder="Choisir"></p-dropdown>
            </div>
          </div>
          <div class="layout--gap">
            <div class="w-full">
              <label class="label-top" for="jobCategoriesDropdown" i18n>Emploi</label>
              <div class="layout--row layout--gap">
                <p-dropdown
                  class="w-full"
                  [filter]="true"
                  [options]="jobCategoryOptions | emTranslate"
                  [styleClass]="
                    form.controls.jobCategoryId.invalid && form.controls.jobCategoryId.touched
                      ? 'error--input'
                      : ''
                  "
                  [formControl]="form.controls.jobCategoryId"
                  [virtualScroll]="true"
                  [virtualScrollItemSize]="30"
                  id="jobCategoriesDropdown"
                  i18n-placeholder
                  placeholder="Choisir"
                  i18n-emptyFilterMessage
                  emptyFilterMessage="Aucun résultat"
                  filterBy="name"
                  optionLabel="name"
                  optionValue="value"></p-dropdown>
                <em-text-indicator
                  [text]="
                    jobCategoryIdToRiskClass[form.controls.jobCategoryId.value ?? '']
                  "></em-text-indicator>
              </div>
            </div>

            <div class="w-full"></div>
          </div>
        </div>
      </form>

      @if (protectionBuilderInputs$ | async; as protectionBuilderInputs) {
        <h3 i18n>Protection</h3>
        <em-protection-builder
          [ratesVersion]="ratesVersion"
          [age]="protectionBuilderInputs.age"
          [sex]="protectionBuilderInputs.sex"
          [smoker]="protectionBuilderInputs.smoker"
          [categoryCode]="categoryCode"
          [jobRiskClass]="protectionBuilderInputs.jobRiskClass"
          [surchargeRate]="protectionBuilderInputs.surchargeRate"
          [blocked]="form.invalid"></em-protection-builder>
      }
    </p-card>
  </div>
</em-main>
